import React from 'react';
import { IEscrowExpectedIncomingCheckData } from 'types/accounting/data/IEscrowExpectedIncomingCheckData';
import { DateFormat, getDateString } from 'ui-toolkit/utilities/getDateString';
import { showBorrowerNames } from 'utilities/accounting/showBorrowerNames';
import { AddressDisplay } from './AddressDisplay';
import { Currency } from 'ui-toolkit/components/Currency';
import { ButtonTW } from 'tailwindComponents/buttonTW/ButtonTW';
import { IEscrowExpectedIncomingWireData } from 'types/accounting/data/IEscrowExpectedIncomingWireData';
import { IEscrowExpectedIncomingAchData } from 'types/accounting/data/IEscrowExpectedIncomingAchData';
import { BankAccountTooltip } from './BankAccountTooltip';
import { useHasFeatureFlag } from 'selectors/useHasFeatureFlag';

export interface IExpectedDisplayProps {
  expected: IEscrowExpectedIncomingCheckData | IEscrowExpectedIncomingWireData | IEscrowExpectedIncomingAchData;
  actionLabel?: string;
  accountNumber: string;
  onAction?: () => void;
}

export const ExpectedDisplay: React.FC<IExpectedDisplayProps> = ({
  expected,
  actionLabel,
  onAction,
  accountNumber,
}) => {
  const isSpruceWithZillowEnabled = useHasFeatureFlag('pinecone.spruce-with-zillow-closing');
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  const bank = expected.escrowFile.depositEscrowBankAccount;
  const base = isSpruceWithZillowEnabled ? bank.legalName : bank.spruceName;
  const selectedNickname = isZillowClosingEnabled ? bank.nickname : bank.spruceNickname;
  const bankDisplayName = selectedNickname ? `${base} ${selectedNickname}` : base;
  return (
    <div className={'w-full flex flex-row gap-1 items-center even:bg-slate-100 hover:bg-slate-200 px-2'}>
      <div className={'basis-44'}>{getDateString(DateFormat.shortDateTime, expected.createdAt, true)}</div>
      <div className={'basis-32'}>{expected.escrowFile.order.fileNumber}</div>
      <div className={'basis-52'}>{showBorrowerNames(expected.escrowFile.order)}</div>
      <div className={'grow'}>
        <AddressDisplay {...expected.escrowFile.order.propertyAddress} />
      </div>
      <div className={'basis-40'}>
        {bankDisplayName}
        {accountNumber !== expected.escrowFile.depositEscrowBankAccount.accountNumber && <BankAccountTooltip />}
      </div>
      <div className={'basis-32'}>
        <Currency value={expected.amountCents} valueIsCents />
      </div>
      {actionLabel && onAction && (
        <ButtonTW className={'basis-36'} onClick={onAction} data-test-id={'expected-action-button'}>
          {actionLabel}
        </ButtonTW>
      )}
      {!actionLabel && !onAction && <div className={'basis-36'}>&nbsp;</div>}
    </div>
  );
};
